import React from 'react';
import { UserButton } from '@clerk/clerk-react';
import { NavLink, useNavigate } from 'react-router-dom';

import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard');
  }

  return (
    <header className="dashboard-navbar">
      <div className="dashboard-navbar-brand" onClick={handleClick}>
        <h2>Say Yes TN</h2>
        <p>Dashboard</p>
      </div>

      <nav className="dashboard-navbar-links">
        <NavLink to="/dashboard" end className={({ isActive }) => `dashboard-nav-link ${isActive ? 'active' : ''}`}>
          Proposal Pages
        </NavLink>
        <NavLink to="/dashboard/wishlist" className={({ isActive }) => `dashboard-nav-link ${isActive ? 'active' : ''}`}>
          Dating Waitlist
        </NavLink>
        <NavLink to="/dashboard/birthday" className={({ isActive }) => `dashboard-nav-link ${isActive ? 'active' : ''}`}>
          Birthday Pages
        </NavLink>
      </nav>

      <div className="user-btn">
        <UserButton />
      </div>
    </header>
  );
};

export default Navbar;